var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0089 8.04444C10.4533 8.04444 10.7822 7.74222 10.7822 7.33333C10.7822 6.90667 10.4533 6.62222 10.0089 6.62222C9.55556 6.62222 9.22667 6.90667 9.22667 7.33333C9.22667 7.74222 9.55556 8.04444 10.0089 8.04444Z",
    fill: "#6C7C83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.648 13.8222V8.84444H9.35103V13.8222H10.648Z",
    fill: "#6C7C83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM9.99933 3.06667C6.17015 3.06667 3.06599 6.17083 3.06599 10C3.06599 13.8292 6.17015 16.9333 9.99933 16.9333C13.8285 16.9333 16.9327 13.8292 16.9327 10C16.9327 6.17083 13.8285 3.06667 9.99933 3.06667Z",
    fill: "#6C7C83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBox);
export default __webpack_public_path__ + "static/media/InfoBox.9d892f479cd0a6ecad97e02e86b7d501.svg";
export { ForwardRef as ReactComponent };